import { CustomButton } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

interface IStyleProps {
  bgColor?: string;
  width?: string;
  margin?: string;
  borderLeft?: any;
  border?: any;
  padding?: any;
  height?: string;
}

export const ItemVariantGridWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  margin: 20px 0px 20px;
  background: #fff;
  .variant-grid-icon {
    margin-right: 15px;
    height: 22px;
    width: 19px;
    margin-bottom: 4px;
    & + .orange-semi-bold {
      margin-left: 10px;
    }
  }
  .variant-table {
    td,
    th {
      vertical-align: middle;
      img {
        width: 22px;
        height: 22px;
      }
      &.related-media-column {
        img {
          height: 30px;
          width: 30px;
        }
      }
    }
  }
  ${CustomButton} {
    min-width: 120px;
    width: 120px;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 0px;
  }
  .vertical-align-top {
    vertical-align: top !important;
  }
`;
export const ColoredBlocks = styled.div<IStyleProps>`
  height: 20px;
  width: 20px;
  background-color: ${(props) => props.bgColor || "#000"};
  border-radius: 4px;
  border: 1px solid #aaa;
`;
